import { Config } from './config';

const create = Config.createClient;

export const jsonClient = create();

export default create;